import { I18nt } from 'utils';
import styles from './Home.module.less';
import NavigationCards from './NavigationCards';
import PageDivider from 'components/PageDivider';
import BannerWithImage from 'components/BannerWithImage';
import SocialMediaIcons from 'components/SocialMediaIcons';
import { Button } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { useLayoutContext } from 'components/Layout/LayoutContext';

const Banner = () => (
	<div className={styles.bannerContainer}>
		<h3>{I18nt('hola')}</h3>
		<h3>{I18nt('bienvenido_a')}</h3>
		<h1>{I18nt('tu_isbm')}</h1>
	</div>
);

const SectionTitle = () => (
	<div className={styles.pageHader}>
		<h2>{I18nt('ahora_a_un')}</h2>
		<p>{I18nt('puedes_elegir_una')}</p>
		<PageDivider className={styles.divider} />
	</div>
);

const SocialMedia = () => {
	return (
		<div className={styles.socialMediaContainer}>
			<div>
				<p>{I18nt('siguenos_en_nuestras')}</p>
				<div className={styles.iconsContainer}>
					<SocialMediaIcons />
				</div>
			</div>
		</div>
	);
};

const MenuButton = () => {
	const { isOpen, setIsOpen } = useLayoutContext();
	const btnText = isOpen ? (
		<>
			<MinusOutlined />
			&nbsp;
			{I18nt('cerrar_el_menu')}
		</>
	) : (
		<>
			<PlusOutlined />
			&nbsp;
			{I18nt('abrir_el_menu')}
		</>
	);
	return (
		<div className={styles.menuButtonWrapper}>
			<Button onClick={() => setIsOpen((current) => !current)} type='default'>
				{btnText}
			</Button>
		</div>
	);
};

export default function Home() {
	return (
		<section className={styles.section}>
			<BannerWithImage>
				<Banner />
				<div className={styles.mainContianer}>
					<PageDivider />
					<SectionTitle />
					<NavigationCards />
					<MenuButton />
					<PageDivider className={styles.dividerBottom} />
				</div>
				<SocialMedia />
			</BannerWithImage>
		</section>
	);
}
